import React from "react";
import { EMPTY_VALUE_PLACEHOLDER, getClassName } from "@sscs/utils";
import { SECRET_LIVENESS_SHORT_LABEL } from "../../../constants";
import styles from "./secretLiveness.module.scss";
const SecretLiveness = ({ liveness, exposed, className, }) => {
    const livenessClassName = getClassName({ [styles["active-secret"]]: exposed && liveness === "active" }, className);
    if (liveness === "active" || liveness === "inactive") {
        return (React.createElement("div", { className: livenessClassName }, SECRET_LIVENESS_SHORT_LABEL[liveness]));
    }
    return React.createElement("div", null, EMPTY_VALUE_PLACEHOLDER);
};
export default SecretLiveness;
//# sourceMappingURL=SecretLiveness.js.map